// Mock data for LoadSurf AI Landing Page

export const loadboardPartners = [
  { id: 1, name: 'DAT' },
  { id: 2, name: 'Truckstop' },
  { id: 3, name: 'TQL' },
  { id: 4, name: 'Shipwell' },
  { id: 5, name: 'Emerge' },
  { id: 6, name: 'Cargobot' },
  { id: 7, name: 'Axle' },
  { id: 8, name: 'LDI' },
  { id: 9, name: 'Mode Global' },
  { id: 10, name: 'NTG Freight' },
];

export const features = [
  {
    id: 1,
    title: 'One Dashboard',
    description: 'Search all your private loadboards from a single, unified interface. No more tab switching.',
    icon: 'Layout',
  },
  {
    id: 2,
    title: 'Smart Filters',
    description: 'Filter loads by origin, destination, weight, rate, and equipment type across all boards.',
    icon: 'Filter',
  },
  {
    id: 3,
    title: 'Real-Time Sync',
    description: 'Loads are synced in real-time. Never miss a high-paying opportunity.',
    icon: 'RefreshCw',
  },
  {
    id: 4,
    title: 'Local-First Security',
    description: 'Your loadboard credentials never leave your computer. We never see or store your passwords.',
    icon: 'Shield',
  },
  {
    id: 5,
    title: 'Unlimited Users',
    description: 'Add your entire team without extra charges. Collaborate seamlessly.',
    icon: 'Users',
  },
  {
    id: 6,
    title: 'Windows & Mac',
    description: 'Native desktop apps for Windows 10+ and macOS. Fast, reliable, and always available.',
    icon: 'Smartphone',
  },
];

export const howItWorks = [
  {
    step: 1,
    title: 'Add Your Loadboards',
    description: 'Connect your DAT, Truckstop, TQL, Emerge and other private loadboard accounts securely.',
  },
  {
    step: 2,
    title: 'Set Your Preferences',
    description: 'Define your lanes, equipment type, and minimum rate requirements.',
  },
  {
    step: 3,
    title: 'Search Everything',
    description: 'Browse loads from all connected boards in one view with powerful filters.',
  },
  {
    step: 4,
    title: 'Book & Move',
    description: 'Click through to book directly on the original loadboard. Simple and fast.',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Mike Thompson',
    role: 'Fleet Owner',
    company: 'Thompson Trucking (45 trucks)',
    content: 'I used to have 12 tabs open just to check loads. LoadSurf AI changed everything. Now my team finds the best loads in seconds instead of hours.',
    avatar: 'https://images.unsplash.com/photo-1629507208649-70919ca33793?w=100&h=100&fit=crop',
  },
  {
    id: 2,
    name: 'Sarah Chen',
    role: 'Dispatch Manager',
    company: 'Chen Logistics',
    content: 'The time savings alone is incredible. My dispatchers are now 3x more productive finding loads across all our broker accounts.',
    avatar: 'https://images.unsplash.com/photo-1590650213165-c1fef80648c4?w=100&h=100&fit=crop',
  },
  {
    id: 3,
    name: 'Robert Martinez',
    role: 'Fleet Owner',
    company: 'Martinez Transport (28 trucks)',
    content: "Finally, someone understood our pain. No more logging into dozens of portals. LoadSurf AI is a game-changer for our dispatch team.",
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  },
  {
    id: 4,
    name: 'Jennifer Walsh',
    role: 'Head of Operations',
    company: 'Midwest Freight Solutions',
    content: "We manage 60+ trucks and used to spend hours across different loadboards. LoadSurf AI consolidated everything into one view. Absolute lifesaver.",
    avatar: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=100&h=100&fit=crop',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'Which loadboards does LoadSurf AI support?',
    answer: 'LoadSurf AI currently supports DAT, Truckstop, TQL, Shipwell, Emerge, Cargobot, Axle, LDI, Mode Global, NTG Freight and more. We\'re constantly adding new integrations.',
  },
  {
    id: 2,
    question: 'How is my loadboard login information secured?',
    answer: 'Your credentials are stored locally on your machine using bank-level encryption (AES-256). Your login information never leaves your computer — we never see or store your passwords on any server.',
  },
  {
    id: 3,
    question: 'Can my whole team use LoadSurf AI?',
    answer: 'Yes! You can add your entire dispatch team, drivers, and office staff. Everyone can collaborate seamlessly.',
  },
  {
    id: 4,
    question: 'Does LoadSurf AI book loads automatically?',
    answer: 'LoadSurf AI aggregates and displays loads from all your connected boards. When you find a load you want, click through to book directly on the original loadboard. This ensures compliance with each broker\'s terms.',
  },
  {
    id: 5,
    question: 'What platforms are supported?',
    answer: 'LoadSurf AI is available as a native desktop app for Windows 10+ (64-bit) and macOS (both Apple Silicon and Intel Macs). Mobile apps are coming soon.',
  },
];

export const stats = [
  { value: '10+', label: 'Loadboards Supported' },
  { value: '1K+', label: 'Carriers Using' },
  { value: '3x', label: 'Faster Load Search' },
  { value: '99.9%', label: 'Uptime' },
];

// Release information - fallback used when the artifacts API is unreachable
export const releaseInfo = {
  version: '0.6.0',
  downloads: {
    mac: {
      url: 'https://api.bubba.ai/api/v1/app-artifacts/loadsurf/mac/Loadsurf-0.6.0-mac-universal.dmg',
      fileName: 'Loadsurf-0.6.0-mac-universal.dmg',
    },
    windows: {
      url: 'https://api.bubba.ai/api/v1/app-artifacts/loadsurf/win/Loadsurf-0.6.0-win-x64.exe',
      fileName: 'Loadsurf-0.6.0-win-x64.exe',
    },
  },
};
